import styled from "styled-components";

export const StyledButton = styled.button`
  display: flex;
  gap: 4px;
  background: ${({ bg }) => bg || "#ffffff"};
  border-radius: ${({ borderRadius }) => borderRadius || "100px"};
  border: ${({ border }) => border || "1px solid #eee"};
  min-width: ${({ minWidth }) => minWidth || "34px"};
  height: ${({ height }) => height || "34px"};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
  color: ${({ color, disabled }) => (!disabled ? color : "#000")};
  font-size: ${({ fontSize }) => fontSize || "14px"};
  margin: ${({ margin }) => margin || "0"};
  position: ${({ position }) => position};
  outline: none;
  span {
    font-size: inherit;
  }

  --calcite-loader-progress-color: var(--opsColor);
  --calcite-font-size--3: 1rem;
  --calcite-internal-loader-size: 1.5rem;
  --calcite-loader-spacing: 0rem;
`;

export const StyledFilterButton = styled.div`
  border: 1px solid
    ${({ isActive, activeColor }) =>
      isActive ? activeColor ?? "#535353" : "#e3e2e2"};
  background: ${({ isActive, activeColor, bg }) =>
    isActive ? activeColor ?? "#535353" : bg ?? "none"};
  color: ${({ isActive }) => (isActive ? "#fff;" : "#535353")};
  cursor: pointer;
  border-radius: 8px;
  padding: 4px 6px;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s;

  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;
  }

  svg {
    width: ${({ svgSize }) => svgSize || "16px"};
    height: ${({ svgSize }) => svgSize || "16px"};
    padding: 0;
    display: flex;
  }
`;

export const StyledNewButton = styled.button`
  font-size: ${({ size }) => (size === "sm" ? "10px" : "14px")};
  padding: 4px 12px;
  box-sizing: border-box;
  min-height: ${({ size }) => (size === "sm" ? "" : "33px")};
  min-width: ${({ size }) => (size === "sm" ? "" : "33px")};
  background: ${({ bg, selected }) =>
    selected ? "rgba(0, 0, 0, 0.5)" : bg || "rgba(0, 0, 0, 0.08)"};
  border-radius: ${({ size }) => (size === "sm" ? "4px" : "8px")};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  color: ${({ color, selected, disabled }) =>
    selected
      ? "#fff"
      : !disabled
      ? color || "rgb(73,73,73)"
      : "rgba(0,0,0,0.2)"};
  cursor: pointer;
  border: none;
  outline: none;
  transition: background 0.2s;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  position: ${({ position }) => position};
  --calcite-loader-progress-color: ${({ loaderColor }) =>
    loaderColor ? loaderColor : "var(--opsColor)"};
  --calcite-font-size--3: 1rem;
  --calcite-internal-loader-size: 1.5rem;
  --calcite-loader-spacing: 0px;
`;

export const StyledButtonIcon = styled(StyledNewButton)`
  padding: 4px;
  width: ${({ size, width }) => (size === "sm" ? "" : width ?? "33px")};
  min-height: ${({ size, height }) => (size === "sm" ? "" : height ?? "33px")};
  min-width: ${({ size, width }) => (size === "sm" ? "" : width ?? "33px")};

  svg {
    width: ${({ size }) => (size === "sm" ? "14px" : "")};
    height: ${({ size }) => (size === "sm" ? "14px" : "")};
  }
`;
